const CoarseSelection = {
    SPECIFIC: "specific",
    ALL_ACTIVE: "all_active",
    ALL: "all"
};

export default CoarseSelection;


// WEBPACK FOOTER //
// ./web/js/enums/CoarseSelection.js